// src/data/growth-pattern-diagnosis.js
export const growthPatternQuestions = [
  { id: 'q1', text: '新しいスキルを学び始めた時、自分は他の人よりも早く習得できる方だと感じることが多い。', factor: 'initialConfidence' },
  { id: 'q2', text: '物事を学ぶ際、少し理解しただけで「全体像を把握した」と感じやすい。', factor: 'initialConfidence' },
  { id: 'q3', text: '自分の能力について、他人からフィードバックを受けることに抵抗は少ない方だ。', factor: 'selfAwareness' },
  { id: 'q4', text: '自分の知識やスキルが、実はまだ表面的であることに気づき、愕然とすることがある。', factor: 'selfAwareness' },
  { id: 'q5', text: '一度「自分はこれが苦手だ」と感じると、その分野の学習意欲が大きく低下してしまう。', factor: 'resilience' },
  { id: 'q6', text: 'スキルが伸び悩む「停滞期」は、成長のために必要なプロセスだと捉えることができる。', factor: 'resilience' },
  { id: 'q7', text: '長期的な目標を立てるよりも、目先のタスクをこなすことに集中しがちだ。', factor: 'planning' },
  { id: 'q8', text: '自分の成長の段階を、客観的に「今はどのレベルか」と分析するのが得意だ。', factor: 'planning' },
];
